// @flow

import { difference, filter, intersectionBy } from 'lodash';

import { FIELD_KEYS } from './constants';

import type { FieldSchema } from 'app/developer-v3/platformSchema/field';

export const findCommonFields = (
  fields: Array<FieldSchema>,
  newFields: Array<FieldSchema>
) => {
  const commonKeyedFields = filter(
    intersectionBy(newFields, fields, FIELD_KEYS.key),
    FIELD_KEYS.key
  );
  const commonDynamicFields = filter(
    intersectionBy(newFields, fields, FIELD_KEYS.source),
    FIELD_KEYS.source
  );
  return [...commonKeyedFields, ...commonDynamicFields];
};

export const findUniqueFields = (
  fields: Array<FieldSchema>,
  newFields: Array<FieldSchema>
) => {
  const commonFields = findCommonFields(fields, newFields);
  const uniqueFields = difference(newFields, commonFields);

  return uniqueFields;
};
